const PersonalLoanIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path opacity='0.2' d='M2.25 9H21.75L12 3L2.25 9Z' fill='#827CA8' />
            <path
                d='M2.25 9H21.75L12 3L2.25 9Z'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.25 9V16.5'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.75 9V16.5'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.25 9V16.5'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M18.75 9V16.5'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M3 16.5H21'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M1.5 19.5H22.5'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default PersonalLoanIcon;
